const _version = "3.2.1"
function version() {
    return _version
}
export default version
